import { ImageIcon } from 'shared-widget-components/src/components/Icons';

export const CarouselLoadingSkeleton = () => {
  return (
    <div className='flex justify-center px-2 md:px-4 min-h-[200px] mx-auto w-full pt-2 mt-2 animate-pulse'>
      <div className='max-w-[1240px] flex min-[350px]:flex-col md:flex-row md:px-2 w-full  lg:px-2'>
        <div className='relative min-[350px]:w-full min-[350px]:p-0 md:p-4 md:w-[65%] min-[350px]:h-1/2 sm:h-[70%] md:h-full flex items-center justify-center overflow-hidden'>
          <ImageIcon width={16} height={16} />
        </div>
        <div className='min-[350px]:w-full md:w-[35%] min-[350px]:h-[316px] md:h-fit flex flex-col min-[350px]:px-4 min-[350px]:py-0 md:px-6 md:py-6'>
          <div className='flex px-1 w-full min-[350px]:mt-4 md:mt-4 min-[350px]:mb-1 md:mb-4 min-[1200px]:mb-24 gap-2 justify-between'>
            <div className='h-3 w-16 bg-slate-200 rounded'></div>
            <div className='h-3 w-16 bg-slate-200 rounded'></div>
          </div>
          <div className='h-full'>
            <div className='h-3 w-60 bg-slate-200 rounded mt-16'></div>
            <div className='h-2 w-48 bg-slate-200 rounded mt-4'></div>
            <div className='h-2 w-44 bg-slate-200 rounded mt-4'></div>
            <div className='h-2 w-28 bg-slate-200 rounded mt-2'></div>
          </div>
        </div>
      </div>
    </div>
  );
};
